import Vue from 'vue'
import authHeader from './auth-header'
import refreshHeader from './auth-refresh'

class AuthService {
  login (user) {
    return Vue.axios
      .post('auth/login', { email: user.email, password: user.password }, { skipAuthRefresh: true })
      .then(({ data, ...response }) => {
        if (data.access_token) {
          localStorage.setItem('user', JSON.stringify(data))
        }
        return data
      })
  }

  refresh () {
    return Vue.axios
      .post('auth/refresh', {}, { headers: refreshHeader(), skipAuthRefresh: true })
      .then(({ data, ...response }) => {
        if (data.access_token) {
          let user = JSON.parse(localStorage.getItem('user'))
          // update access token
          user.access_token = data.access_token
          localStorage.setItem('user', JSON.stringify(user))
        }
        return data
      })
  }

  logout () {
    return Vue.axios
      .delete('auth/logout', { headers: authHeader() })
      .then(({ data, ...response }) => {
        localStorage.removeItem('user')
        return data
      })
  }

  forgot (email) {
    return Vue.axios
      .post('auth/forgot', { email: email })
      .then(({ data, ...response }) => {
        return data
      })
  }

  reset (reset) {
    return Vue.axios
      .post('auth/reset', {
        token: reset.token,
        password: reset.password,
        confirm_password: reset.confirm
      })
      .then(({ data, ...response }) => {
        return data
      })
  }
}
export default new AuthService()
